import type { ReactNode } from 'react';
import { useMemo } from 'react';

import { useRouteLoaderData } from '@remix-run/react';
import type { SocialsData, TSocialsElement } from '@shared/dream-components';
import { SocialsElement } from '@shared/dream-components';

import type { Publication } from '~/interfaces/publication';
import type { RootLoaderData } from '~/root';

interface Props {
  node: TSocialsElement;
  children: ReactNode | ReactNode[];
}

const Socials = ({ node, children }: Props) => {
  const { site } = useRouteLoaderData('root') as RootLoaderData;

  const nodeWithData = useMemo(() => {
    const nodeData = Object.keys(node?.attrs?.data || {}).reduce((pv: SocialsData, cv: string) => {
      if (cv in site.publication) {
        pv[cv as keyof SocialsData] = site.publication[cv as keyof Publication];
        return pv;
      }

      return pv;
    }, {});

    return {
      ...node,
      attrs: {
        ...node.attrs,
        data: nodeData,
      },
    };
  }, [node, site.publication]);

  return (
    <SocialsElement isLive element={nodeWithData}>
      {children}
    </SocialsElement>
  );
};

export default Socials;
